import {
  deletePurchaseOrderApi,
  listOfPurchaseOrder,
  viewPurchaseOrderWORO,
} from "Api/PurchaseOrder";
import BaseButton from "Components/Base/BaseButton";
import Loader from "Components/Base/BaseLoader";
import BaseModal from "Components/Base/BaseModal";
import BasePanel from "Components/Base/BasePanel";
import TableContainer from "Components/Base/BaseTable";
import DeleteModal from "Components/Base/DeleteModal";
import {
  checkStatusCodeSuccess,
  DownloadLabel,
  notFound,
  pdfDownload,
  rupeeSymbol,
  Search,
} from "Components/constants/Common";
import {
  ActionKey,
  ActionLabel,
  NoLabel,
  POPublishLabel,
  StatusLabel,
  YesLabel,
} from "Components/constants/Role";
import { StyleSheet } from "@react-pdf/renderer";
import { SetStateAction, useEffect, useMemo, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  AddGRNLabel,
  GRN_STATUS_LABEL,
  PO_STATUS_LABEL,
  POStatusKey,
  PurchaseOrderLabel,
  PurchaseOrderOptions,
  VendorIdLabel,
  VendorNameLabel,
} from "Components/constants/PurchaseOrder";
import { ROReturnLabels } from "Components/constants/ReturnRONPO";
import { deletePO, POPdfApi, updatePOStatus } from "Api/RoPurchaseOrder";
import {
  AMOUNT_LABEL,
  DRAFT_LABEL,
  PENDING_LABEL,
  PENDING_QTY_LABEL,
  PO_DETAILS_LABEL,
  PO_NO_LABEL,
  PR_NO_LABEL,
  PRODUCT_CODE_LABEL,
  PUBLISH_LABEL,
  PUBLISHED_LABEL,
  RECEIVED_QTY_LABEL,
  TOTAL_AMOUNT_LABEL,
  TOTAL_QTY_LABEL,
  VENDOR_ID_LABEL,
  VENDOR_NAME_LABEL,
} from "Components/constants/ROModule";

interface GRNHistoryItem {
  id: number;
  ro_po_id: number;
  product_id: number;
  received_quantity: number;
  pending_quantity: number;
  version: number;
  product: {
    id: number;
    product_code: string;
  };
}

interface PanelDataProps {
  id: number;
  part_id: number;
  vendor_id: number;
  user_draft_id: string;
  po_no: string;
  type: string;
  status: string;
  total_amount: number;
  po_status: string;
  grnHistory: GRNHistoryItem[];
  delivery_date: string;
  createdAt: string;
  total_cost?: string;
  out_standing_amount?: number;
  store_id: number;
  isGrn?: boolean;
  authUser: {
    id: number;
    name: string;
    user_draft_id?: string;
  };
  vendor: {
    id: number;
    name: string;
  };
  indent_draft_id: string;
  purchaseOrderItem: PurchaseOrderItem[];
}

interface PurchaseOrderItem {
  id: number;
  product_quantity: number;
  received_quantity: number;
  quantity: number;
  product: {
    id: number;
    product_code: string;
  };
}

const styles = StyleSheet.create({
  page: {
    fontSize: 11,
    flexDirection: "column",
    height: "100vh",
    width: "100%",
    padding: "2%",
  },
  header: {
    flexDirection: "column",
    justifyContent: "center",
    alignContent: "center",
    textAlign: "center",
    height: 100,
  },
  logo: {
    width: 100,
    height: 100,
    border: "1px solid #ddd",
  },
  table: {
    width: "100%",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    borderRadius: 4,
  },
  headerRow: {
    backgroundColor: "#f5f5f5",
    padding: 10,
    fontSize: 24,
    borderStyle: "solid",
    borderColor: "#ddd",
  },
  headRow: {
    display: "flex",
    flexDirection: "row",
    backgroundColor: "#f5f5f5",
    borderBottomWidth: 1,
    justifyContent: "space-between",
    borderStyle: "solid",
    borderColor: "#f5f5f5",
    height: 40,
  },
  headCell: {
    padding: 8,
    backgroundColor: "#f5f5f5",
  },
  row: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderStyle: "solid",
    borderColor: "#ddd",
    height: 40,
  },
  rowSpace: {
    flexDirection: "row",
    borderBottomWidth: 1,
    margin: "0 20px",
    borderStyle: "solid",
    borderColor: "#ddd",
    textAlign: "center",
    height: 45,
  },
  cell: {
    flex: 1,
    padding: 8,
    backgroundColor: "white",
    border: "1px solid #ddd",
  },
  cellTitle: {
    flex: 1,
    padding: 8,
    backgroundColor: "gray",
    color: "white",
  },
  footer: {
    position: "absolute",
    bottom: 20,
    left: 20,
    right: 20,
    fontSize: 10,
    color: "grey",
  },
  watermark: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    fontSize: 50,
    color: "rgba(0, 0, 0, 0.1)",
  },
});
let totalCost = 0;
const PurchaseOrder = () => {
  document.title = PurchaseOrderLabel;
  const navigate = useNavigate();
  const [customerData, setCustomerData] = useState<Array<any>>([]);
  const [customerSearchData, setCustomerSearchData] = useState<Array<any>>([]);
  const [loader, setLoader] = useState<boolean>(false);
  const [downloadLoader, setDownloadLoader] = useState<boolean>(false);
  const [panel, setPanel] = useState(false);
  const [panelId, setPanelId] = useState<number>();
  const [panelData, setPanelData] = useState<PanelDataProps>();
  const [btnLoader, setBtnLoader] = useState<boolean>(false);
  const [deleteOpen, setDeleteOpen] = useState<boolean>(false);
  const [deleteId, setDeleteId] = useState<number>();
  const [totalNumberOfRows, setTotalNumberOfRows] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [columnName, setColumnName] = useState("id");
  const [sortOrder, setSortOrder] = useState("desc");
  const [currentPage, setCurrentPage] = useState(1);
  const [customPageSize, setCustomPageSize] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [selectedROOId, setSelectedROOId] = useState<number | null>(null);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [publishModalOpen, setPublishModalOpen] = useState<boolean>(false);
  const [requiredQty, setRequiredQty] = useState<number[]>([]);
  const [prodCode, setProdCode] = useState<string[]>([]);
  const [pageLoader, setPageLoader] = useState<boolean>(false);

  const handleFetchSorting = (
    page: any,
    id: SetStateAction<string>,
    order: SetStateAction<string>
  ) => {
    setCurrentPage(page);
    setColumnName(id);
    setSortOrder(order);
  };

  const openDeleteModal = (poid: number) => {
    setSelectedROOId(poid);
    setDeleteModal(true);
  };

  const closeDeleteModal = () => {
    setDeleteModal(false);
    setSelectedROOId(null);
  };

  const openPublishModal = (poid: number) => {
    setSelectedROOId(poid);
    setPublishModalOpen(true);
  };

  const closePublishModal = () => {
    setPublishModalOpen(false);
    setSelectedROOId(null);
  };

  const handleFetchData = (page: any) => {
    setCurrentPage(page);
  };

  const handleSearchValueChange = (value: any) => {
    if (value !== searchValue) {
      setCurrentPage(1);
      setSearchValue(value);
    }
  };

  const handleDownload = (row: any) => {
    pdfDownload(
      POPdfApi,
      row?.id,
      `purhcase_order_${row?.po_no}.pdf`,
      setPageLoader
    );
  };

  const handleDeleteROO = () => {
    if (selectedROOId !== null) {
      setBtnLoader(true);

      deletePO(selectedROOId)
        .then((res: any) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            fetchCustomerData();
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error: any) => {
          toast.error(error?.response?.data?.message || error?.message);
        })
        .finally(() => {
          setBtnLoader(false);
          closeDeleteModal();
        });
    } else {
      setBtnLoader(false);
    }
  };

  const IndentColumns = useMemo(
    () => [
      {
        header: PR_NO_LABEL,
        accessorKey: "partRequisition.pr_no",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: PO_NO_LABEL,
        accessorKey: "po_no",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: VENDOR_NAME_LABEL,
        accessorKey: "vendor.name",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: VENDOR_ID_LABEL,
        accessorKey: "user_draft_id",
        enableSorting: true,
        enableColumnFilter: false,
      },
      {
        header: AMOUNT_LABEL,
        accessorKey: "total_amount",
        enableSorting: true,
        enableColumnFilter: false,
        cell: (cell: any) => {
          return rupeeSymbol(cell?.row?.original?.total_amount);
        },
      },
      {
        header: GRN_STATUS_LABEL,
        accessorKey: POStatusKey,
        cell: (cell: any) => {
          return (
            <span
              className={
                cell.row.original?.po_status === PurchaseOrderOptions.RECEIVED
                  ? "badge bg-success"
                  : cell.row.original?.po_status ===
                    PurchaseOrderOptions.PARTIALLY_RECEIVED
                  ? "badge bg-primary"
                  : "badge bg-info"
              }
            >
              {cell.row.original?.po_status}
            </span>
          );
        },
        enableColumnFilter: false,
      },
      {
        header: PO_STATUS_LABEL,
        accessorKey: "type",
        enableSorting: true,
        enableColumnFilter: false,
        cell: (cell: any) => {
          const status = cell?.row?.original?.type;
          return (
            <div className="d-flex justify-content-start gap-2 icon">
              <span
                className={`badge ${
                  status === PUBLISH_LABEL
                    ? "bg-success"
                    : status === DRAFT_LABEL
                    ? "bg-danger"
                    : "bg-warning"
                }`}
              >
                {status === PUBLISH_LABEL
                  ? PUBLISHED_LABEL
                  : status === DRAFT_LABEL
                  ? DRAFT_LABEL
                  : PENDING_LABEL}
              </span>
            </div>
          );
        },
      },
      {
        header: ActionLabel,
        accessorKey: ActionKey,
        cell: (cell: any) => {
          const { type } = cell?.row?.original;
          const isPublish = type === PUBLISH_LABEL;

          return (
            <div className="d-flex justify-content-start enable-action gap-2 icon w-full">
              <span className="tooltip-container">
                <i
                  className={`mdi mdi-download-outline fs-4 text-primary cursor-pointer`}
                  onClick={() => handleDownload(cell?.row?.original)}
                ></i>
                <span className="tooltip-text">{DownloadLabel}</span>
              </span>
              <span className="tooltip-container">
                <i
                  className={`mdi mdi-eye-outline fs-4 text-warning cursor-pointer`}
                  onClick={() => {
                    navigate(`/viewPurchaseOrder/${cell?.row?.original?.id}`, {
                      state: { viewQuotation: true },
                    });
                  }}
                ></i>
                <span className="tooltip-text">{ROReturnLabels.View}</span>
              </span>
              <span className="tooltip-container">
                <i
                  className={`mdi mdi-pencil-outline fs-4 text-info cursor-pointer ${
                    isPublish ? "disabled" : ""
                  }`}
                  onClick={() =>
                    !isPublish &&
                    navigate(`/editPurchaseOrder/${cell?.row?.original?.id}`)
                  }
                  style={
                    isPublish ? { pointerEvents: "none", opacity: 0.5 } : {}
                  }
                ></i>
                <span className="tooltip-text">{ROReturnLabels.Edit}</span>
              </span>

              <span className="tooltip-container">
                <i
                  className={`mdi mdi-delete-outline fs-4 text-danger cursor-pointer ${
                    isPublish ? "disabled" : ""
                  }`}
                  onClick={() =>
                    !isPublish && openDeleteModal(cell?.row?.original?.id)
                  }
                  style={
                    isPublish ? { pointerEvents: "none", opacity: 0.5 } : {}
                  }
                ></i>
                <span className="tooltip-text">{ROReturnLabels.Delete}</span>
              </span>
              <span className="tooltip-container">
                <i
                  className={`mdi mdi-check fs-4 cursor-pointer text-success ${
                    isPublish ? "disabled" : ""
                  }`}
                  onClick={() =>
                    !isPublish && openPublishModal(cell?.row?.original?.id)
                  }
                  style={
                    isPublish ? { pointerEvents: "none", opacity: 0.5 } : {}
                  }
                ></i>
                <span className="tooltip-text">{ROReturnLabels.Publish}</span>
              </span>
            </div>
          );
        },
        enableColumnFilter: false,
        enableSorting: false,
      },
    ],
    [downloadLoader]
  );

  const deletePosition = () => {
    setBtnLoader(true);
    deletePurchaseOrderApi(Number(deleteId))
      .then((resp) => {
        if (checkStatusCodeSuccess(resp?.statusCode)) {
          toast.success(resp?.message);
        } else {
          toast.error(resp?.message);
        }
      })
      .catch((error) => {
        toast.error(error?.response?.data?.message || error?.message);
      })
      .finally(() => {
        setBtnLoader(false);
        setDeleteOpen(!deleteOpen);
        setPanel(!panel);
        fetchCustomerData();
      });
  };

  const fetchCustomerData = () => {
    setLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      limit: customPageSize,
    };
    listOfPurchaseOrder(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          setCustomerData(response.data.purchaseOrder);
          setTotalRecords(response.data.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);
          if (searchValue) {
            fetchSearchCustomerData();
          }
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const handleUpdatePOStatus = () => {
    if (selectedROOId !== null) {
      setBtnLoader(true);

      updatePOStatus(selectedROOId)
        .then((res) => {
          if (checkStatusCodeSuccess(res?.statusCode)) {
            toast.success(res?.message);
            fetchCustomerData();
          } else {
            toast.error(res?.message);
          }
        })
        .catch((error) => {
          toast.error(error?.response?.data?.message || error?.message);
        })
        .finally(() => {
          setBtnLoader(false);
          closePublishModal();
        });
    } else {
      setBtnLoader(false);
    }
  };

  const fetchSearchCustomerData = () => {
    setLoader(true);
    const payload = {
      sortKey: columnName,
      sortValue: sortOrder,
      page: currentPage,
      search: searchValue,
      limit: customPageSize,
    };
    listOfPurchaseOrder(payload)
      .then((response) => {
        if (checkStatusCodeSuccess(response.statusCode)) {
          setCustomerSearchData(response.data.purchaseOrder);
          setTotalRecords(response.data.totalItems);
          setTotalPages(response?.data?.totalPages);
          setTotalNumberOfRows(response?.data?.numberOfRows);
        }
      })
      .catch((error) => {
        return error;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const openDrawer = (state: boolean, data: any) => {
    setPanel(state);
    setPanelId(data?.id);
  };

  useEffect(() => {
    if (panelId) {
      setLoader(true);
      viewPurchaseOrderWORO(panelId)
        .then((resp) => {
          if (checkStatusCodeSuccess(resp?.statusCode)) {
            setPanelData(resp?.data);
            const requiredQuantities =
              resp?.data?.repairOrderPurchaseOrderItem?.map(
                (item: { required_quantity: any }) => item.required_quantity
              );

            setRequiredQty(requiredQuantities);

            const productCodes = resp?.data?.repairOrderPurchaseOrderItem?.map(
              (item: { productVariant: { product: { product_code: any } } }) =>
                item.productVariant?.product?.product_code
            );

            setProdCode(productCodes);
            let resultArray: number[] = [];
            resp?.data?.purchaseOrderItem?.reduce((acc: number, value: any) => {
              const amount =
                Number(value?.rate) * Number(value?.product_quantity);
              const tax = value?.tax?.toString().split("_")?.[0];
              const taxAmount = (amount * tax) / 100;
              const finalAmount = amount + taxAmount;
              resultArray.push(finalAmount);
              return finalAmount;
            }, 0);
            let total_cost = resultArray?.reduce((acc, val) => {
              return (acc += val);
            }, 0);
            totalCost = total_cost;
          }
        })
        .catch((err) => {
          return err;
        })
        .finally(() => setLoader(false));
    }
  }, [panelId]);

  useEffect(() => {
    if (searchValue === "") {
      setCurrentPage(1);
    }
  }, [searchValue]);

  useEffect(() => {
    if (searchValue) {
      fetchSearchCustomerData();
    } else {
      fetchCustomerData();
    }
  }, [currentPage, customPageSize, sortOrder, columnName, searchValue]);

  return (
    <div className="page-content">
      {(pageLoader && <Loader />) || (downloadLoader && <Loader />)}
      <div className="flex-grow-1 mx-3">
        <div className="mb-1 mx-2 d-flex justify-content-between align-items-center">
          <span className="fs-4 d-flex gap-4">{PurchaseOrderLabel}</span>
        </div>
        <div className="card py-2 px-4 overflow-x-auto">
          {loader || customerData.length > 0 ? (
            <TableContainer
              customPageSize={customPageSize}
              setCustomPageSize={setCustomPageSize}
              isGlobalFilter={true}
              columns={IndentColumns}
              data={searchValue ? customerSearchData : customerData || []}
              tableClass="table bg-white"
              trClass="cursor-pointer"
              manualPagination={true}
              manualFiltering={true}
              tableLoader={loader}
              hasManualPagination={true}
              SearchPlaceholder={Search}
              currentPage={currentPage}
              setDrawerOpen={openDrawer}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
              totalRecords={totalRecords}
              onSearch={handleSearchValueChange}
              totalNumberOfRows={totalNumberOfRows}
              fetchData={handleFetchData}
              fetchSortingData={handleFetchSorting}
            />
          ) : (
            <div className="py-4 text-center">
              <div>
                <span className="fs-1 text-success">
                  <RiSearchLine />
                </span>
              </div>
              <div className="mt-4">
                <h5>{notFound.dataNotFound}</h5>
                <p className="text-muted">{notFound.thereIsNoDataFound}</p>
              </div>
            </div>
          )}
        </div>

        <BasePanel
          isOpen={panel}
          onClose={() => setPanel(!panel)}
          size="650px"
          position="end"
          loader={loader}
          title={`${PurchaseOrderLabel} ${panelData?.po_no || ""}`}
          children={
            <>
              <div>
                <div className="container-fluid d-flex flex-column">
                  <div className="d-flex justify-content-end align-items-center gap-2 pb-2">
                    {panelData?.type === "Publish" &&
                      (panelData?.po_status === PurchaseOrderOptions.PENDING ||
                        panelData?.po_status ===
                          PurchaseOrderOptions.PARTIALLY_RECEIVED) && (
                        <BaseButton
                          className="btn btn-success py-1 px-2"
                          onClick={() => navigate(`/add-grn/${panelData?.id}`)}
                        >
                          {AddGRNLabel}
                        </BaseButton>
                      )}
                  </div>
                </div>
                <div className="flex-grow-1">
                  <div className="bg-white my-2">
                    <span className="fw-bold">{PO_DETAILS_LABEL}</span>
                  </div>
                  <div className="list-group list-group-flush">
                    <div className="list-group-item d-flex justify-content-between align-items-center">
                      <div className="col-3">
                        <b>{VendorIdLabel}</b>
                      </div>
                      <div className="col-2 text-dark">
                        {panelData?.user_draft_id || notFound.nullData}
                      </div>
                      <div className="col-4">
                        <b>{VendorNameLabel}</b>
                      </div>
                      <div className="col-3 text-dark">
                        {String(panelData?.vendor?.name)}
                      </div>
                    </div>

                    <div className="list-group-item d-flex justify-content-between align-items-center">
                      <div
                        className={
                          panelData?.po_status ===
                          PurchaseOrderOptions.PARTIALLY_RECEIVED
                            ? "col-2"
                            : "col-3"
                        }
                      >
                        <b>{GRN_STATUS_LABEL}</b>
                      </div>
                      <div
                        className={
                          panelData?.po_status ===
                          PurchaseOrderOptions.PARTIALLY_RECEIVED
                            ? "col-3"
                            : "col-2"
                        }
                      >
                        <span
                          className={
                            panelData?.po_status ===
                            PurchaseOrderOptions.RECEIVED
                              ? "badge bg-success"
                              : panelData?.po_status ===
                                PurchaseOrderOptions.PARTIALLY_RECEIVED
                              ? "badge bg-primary"
                              : "badge bg-info"
                          }
                        >
                          {panelData?.po_status || notFound.nullData}
                        </span>
                      </div>
                      <div className="col-4">
                        <b>{TOTAL_AMOUNT_LABEL}</b>
                      </div>
                      <div className="col-3 text-dark">
                        <i className="mdi mdi-currency-rupee"></i>
                        {panelData?.total_amount?.toFixed(2) || "0.00"}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-7">
                      <table className="table table-bordered">
                        <thead className="border bg-light">
                          <tr>
                            <th>{PRODUCT_CODE_LABEL}</th>
                            <th>{TOTAL_QTY_LABEL}</th>
                            <th>{RECEIVED_QTY_LABEL}</th>
                            <th>{PENDING_QTY_LABEL}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {panelData?.grnHistory?.length! > 0
                            ? panelData!.grnHistory.map(
                                (item: GRNHistoryItem) => (
                                  <tr key={item.id}>
                                    <td>
                                      {item.product?.product_code ||
                                        notFound.nullData}
                                    </td>
                                    <td>
                                      {item.received_quantity +
                                        item.pending_quantity ===
                                      0
                                        ? 0
                                        : item.received_quantity +
                                            item.pending_quantity ||
                                          requiredQty}
                                    </td>
                                    <td>{item.received_quantity || "0"}</td>
                                    <td>{item.pending_quantity || "0"}</td>
                                  </tr>
                                )
                              )
                            : prodCode?.map((code: string, index: number) => (
                                <tr key={index}>
                                  <td>{code || notFound.nullData}</td>
                                  <td>{requiredQty[index] || "0"}</td>
                                  <td>0</td>
                                  <td>{requiredQty[index] || "0"}</td>
                                </tr>
                              ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          }
        />

        <DeleteModal
          btnLoader={Boolean(btnLoader)}
          onCloseClick={() => setDeleteOpen(!deleteOpen)}
          onDeleteClick={() => deletePosition()}
          show={deleteOpen}
        />
      </div>

      <DeleteModal
        show={deleteModal}
        onCloseClick={closeDeleteModal}
        onDeleteClick={handleDeleteROO}
        btnLoader={btnLoader}
      />
      <BaseModal
        open={publishModalOpen}
        toggle={closePublishModal}
        submit={handleUpdatePOStatus}
        title={StatusLabel}
        submitLabel={YesLabel}
        submitLabelColor="success"
        loader={btnLoader}
        closeLabel={NoLabel}
        closeLabelColor="danger"
      >
        <>
          <div>{POPublishLabel}</div>
        </>
      </BaseModal>
    </div>
  );
};

export default PurchaseOrder;
